<script setup lang="ts">
import type { DataTableHeaders } from '@/plugins/vuetify'
import type { TBCustomer } from '@/types/thingsboard'
import type { HDHTTPDevice } from '@/types/httpdevices'



const router = useRouter()
//const storeU = useUtilisateurStore()
//const estChargé = computed(() => storeU.estChargé())

let tbToken = null as string | null

const customers = ref([] as TBCustomer[])
const selectedCustomer = ref(null as TBCustomer | null)
const selectedCustomerName = ref('')
const customerNames = computed(() => customers.value.map(c => c.name))

const devices = ref([] as HDHTTPDevice[])
const selectedDevice = ref(null as HDHTTPDevice | null)
//const selectedDeviceName = ref('')
//const deviceNames = computed(() => devices.value.map(d => d.name))

const search = ref('');
const headers: DataTableHeaders = [
  { title: 'Nom', key: 'name', width: '150px' },
  { title: 'TB ID', key: 'thingsBoardId', width: '300px' },
  { title: 'TB Customer ID', key: 'thingsBoardCustomerId', width: '300px' },
  { title: 'Actions', key: 'actions', sortable: false }
]

function newHTTPDevice() {
  router.push(`/httpdevices/${selectedCustomer.value?.id.id}/0`)
}

function editHTTPDevice(device: HDHTTPDevice) {
  router.push(`/httpdevices/${selectedCustomer.value?.id.id}/${device.id}`)
}

const dialogDelete = useTemplateRef('dialogDelete')
async function deleteHTTPDevice(device: HDHTTPDevice) {
  if (selectedCustomer.value == null) {
    Notify.error('Aucun client sélectionné')
    return
  }

  const result = await dialogDelete.value?.open('Êtes-vous certain de vouloir supprimer cet appareil ?');
  if (!result?.valueOf())
    return

  try {
    const customerId = selectedCustomer.value.id.id
    await apiOmni.delete(`customers/${customerId}/httpdevices/${device.id}`)
    Notify.success('Supprimé')
    await loadDevices()
  } catch (e) {
    Notify.error(e)
  }
}

const onCustomerChanged = async (value: string) => {
  selectedCustomer.value = customers.value.find(c => c.name === value) ?? null
  loadDevices()
}

async function loadDevices() {
  if (selectedCustomer.value === null) {
    return
  }

  selectedDevice.value = null
  devices.value = []

  const customerId = selectedCustomer.value.id.id
  const response = await apiOmni.get(`customers/${customerId}/httpdevices`)
  devices.value.push(...response.data)
  console.log(devices.value)

  return null
}

onMounted(async () => {
  try {
    const response = await apiOmni.post('api/tb/login')
    tbToken = response.data.token

    selectedCustomer.value = null
    customers.value = []

    for (let i = 0; ; ++i) {
      const config2 = {
        headers: { 'X-ThingsBoard': `Bearer ${tbToken}` },
        params: { page: i, pageSize: 25
      }}
      const response2 = await apiOmni.get('api/tb/customers', config2)
      customers.value.push(...response2.data.data)
      if (response2.data.hasNext === false) {
        break
      }
    }

    if (customers.value.length > 0) {
      selectedCustomer.value = customers.value[0]
      selectedCustomerName.value = selectedCustomer.value.name
    }

    //console.log(customers.value)

  } catch (error) {
    console.log('Error:', error)
    Notify.error(error)
  }

  loadDevices()
})
</script>

<template>
  <v-container fluid>
    <v-row align="center">
      <v-col cols="2">
        <v-icon>M3 6H21V4H3C1.9 4 1 4.9 1 6V18C1 19.1 1.9 20 3 20H7V18H3V6M13 12H9V13.78C8.39 14.33 8 15.11 8 16C8 16.89 8.39 17.67 9 18.22V20H13V18.22C13.61 17.67 14 16.88 14 16S13.61 14.33 13 13.78V12M11 17.5C10.17 17.5 9.5 16.83 9.5 16S10.17 14.5 11 14.5 12.5 15.17 12.5 16 11.83 17.5 11 17.5M22 8H16C15.5 8 15 8.5 15 9V19C15 19.5 15.5 20 16 20H22C22.5 20 23 19.5 23 19V9C23 8.5 22.5 8 22 8M21 18H17V10H21V18Z</v-icon>
        <span>{{ selectedCustomer?.name ?? 'Aucun sélectionné' }}</span>

      </v-col>
      <v-col cols="2">
        <v-select
          v-model="selectedCustomerName"
          :items="customerNames"
          label="Site"
          hide-details
          dense
          outlined
          class="mr-2"
          style="width: 300px"
          @update:model-value="onCustomerChanged"
        />
      </v-col>
    </v-row>
    <v-row width="100%">
      <v-col>
        <v-card>
          <v-data-table :headers="headers" :items="devices" :search="search" item-key="id">
            <template #top>
              <v-toolbar flat>
                <v-toolbar-title>Devices {{ selectedCustomerName }}</v-toolbar-title>
                <v-divider class="mx-4" inset vertical/>
                <v-spacer/>
                <v-btn class="mb-2" color="primary" @click="newHTTPDevice">Nouvel appareil</v-btn>
              </v-toolbar>
            </template>
            <template #item.actions="{ item }">
              <v-icon class="me-2" size="small" @click="editHTTPDevice(item)">
                M20.71,7.04C21.1,6.65 21.1,6 20.71,5.63L18.37,3.29C18,2.9 17.35,2.9 16.96,3.29L15.12,5.12L18.87,8.87M3,17.25V21H6.75L17.81,9.93L14.06,6.18L3,17.25Z
              </v-icon>
              <v-icon size="small" @click="deleteHTTPDevice(item)">
                M19,4H15.5L14.5,3H9.5L8.5,4H5V6H19M6,19A2,2 0 0,0 8,21H16A2,2 0 0,0 18,19V7H6V19Z
              </v-icon>
            </template>
          </v-data-table>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
  <DialogConfirm ref="dialogDelete" />
</template>
